<!--
File: TreatmentMatrixUnpaved.vue
Description: Treatment Matrix for Unpaved Roads as the pivot and as the list.
-->
<template>
  <VueTabs v-if="eligible">
    <v-tab id="tab0" v-if="tab0Allowed" :title="$t('tabs.pivot')">
      <TreatmentMatrixUnpavedPivot ref="pivotComponent" />
    </v-tab>

    <v-tab id="tab1" v-if="tab1Allowed" :title="$t('tabs.list')">
      <TreatmentMatrixUnpavedList ref="listComponent" @data-modified="onDataModified" />
    </v-tab>
  </VueTabs>
</template>
<script>
  import { VueTabs, VTab } from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/vue-tabs.css'
  import permissions from "@/mixins/permissionsMixin"
  import { onClose } from '@/mixins/onCloseMixin'

  import TreatmentMatrixUnpavedPivot from './TreatmentMatrixUnpavedPivot.vue'
  import TreatmentMatrixUnpavedList from './TreatmentMatrixUnpavedList.vue'

  export default {
    name: 'treatment-matrix-unpaved',
    mixins: [permissions],

    data() {
      return {
        formName: 'TreatmentMatrix', // Use paved treatment matrix permissions
        eligible: false,
      }
    },

    components: {
      VueTabs,
      VTab,
      TreatmentMatrixUnpavedPivot,
      TreatmentMatrixUnpavedList,
    },

    async mounted() {
      // Check if we are eligible to view the form
      this.eligible = await this.checkIfScreenAllowed()
      if (!this.eligible) {
        this.onClose()
      };
    },

    methods: {
      onClose,

      onDataModified() {
        // Called when data is modified in the list component
        // The pivot component will auto-detect this flag when it becomes active
      }
    },

    computed: {
      tab0Allowed() {
        return this.isScreenAllowed('TreatmentMatrixPivot'); // Use paved pivot permissions
      },
      tab1Allowed() {
        return this.isScreenAllowed('TreatmentMatrixList'); // Use paved list permissions
      }
    },
  }
</script>
<style lang="scss" scoped>
.vue-tabs {
  height: 100%;
}

.vue-tabs .tab-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vue-tabs .tab-content>div {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vue-tabs .nav-tabs>li.active>a,
.vue-tabs .nav-tabs>li.active>a:hover,
.vue-tabs .nav-tabs>li.active>a:focus {
  background-color: #4caf50;
}

.tab-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>